var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDynamics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a7704528bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.464844 80 L 295 80 L 295 302.714844 L 72.464844 302.714844 Z M 72.464844 80 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a7704528bd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8201a",
    d: "M 237.09375 211.085938 C 239.386719 208.921875 241.695312 206.695312 244.015625 204.375 C 302.511719 145.882812 292.933594 90.578125 292.933594 90.578125 L 294.019531 80.980469 L 284.421875 82.066406 C 284.421875 82.066406 229.125 72.496094 170.628906 130.988281 C 168.3125 133.304688 166.085938 135.609375 163.925781 137.898438 L 128.085938 137.90625 L 72.371094 203.960938 L 80.25 211.839844 L 117.984375 187.886719 L 125.34375 187.886719 C 117.332031 200.871094 113.734375 209.160156 113.734375 209.160156 L 165.847656 261.273438 C 165.847656 261.273438 174.132812 257.671875 187.121094 249.660156 L 187.121094 257.015625 L 163.167969 294.753906 L 171.046875 302.636719 L 237.101562 246.917969 Z M 218.132812 156.863281 C 208.546875 147.277344 208.554688 131.757812 218.140625 122.171875 C 227.714844 112.597656 243.246094 112.585938 252.824219 122.167969 C 262.402344 131.75 262.402344 147.296875 252.835938 156.863281 C 243.246094 166.453125 227.710938 166.441406 218.132812 156.863281 Z M 109.6875 222.351562 C 82.691406 243.605469 103.175781 268.542969 92.355469 281.851562 C 92.355469 281.851562 132.40625 291.03125 152.695312 265.363281 L 145.945312 258.472656 C 131.011719 265.507812 110.121094 252.222656 116.652344 229.316406 Z M 109.6875 222.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamics);
export default __webpack_public_path__ + "static/media/Dynamics.847a78a966bbc3f49bb7264afc1bc71a.svg";
export { ForwardRef as ReactComponent };